import { render, staticRenderFns } from "./cz_shuang.vue?vue&type=template&id=a5688348&scoped=true"
import script from "./cz_shuang.vue?vue&type=script&lang=js"
export * from "./cz_shuang.vue?vue&type=script&lang=js"
import style0 from "./cz_shuang.vue?vue&type=style&index=0&id=a5688348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5688348",
  null
  
)

export default component.exports